var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('account-header'),_vm._v(" "),_c('container',{staticClass:"flex-1 my-12"},[_c('row',{attrs:{"wrap":""}},[_c('column',{staticClass:"w-full md:w-4/12 lg:w-3/12 mb-6"},[_c('account-option-list')],1),_vm._v(" "),_c('column',{staticClass:"w-full md:w-8/12 lg:w-9/12"},[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }